import {
  refServiceStatusBlockedColorPalette,
  refServiceStatusClearColorPalette,
  refServiceStatusClosedColorPalette,
  refServiceStatusInProgressColorPalette,
  refServiceStatusNeedsServiceColorPalette,
  refServiceStatusOpenColorPalette,
  refServiceStatusTreatedColorPalette,
  refServiceStatusUnknownColorPalette
} from "../theme/colors";
import {TFunction} from "i18next";

export const getRefServiceStatusColorRef = (
  status: string
): string => {
  switch (status) {
    case "NEEDS_SERVICE":
      return "ref-service-status-needs-service";
    case "BLOCKED":
      return "ref-service-status-blocked";
    case "IN_PROGRESS":
      return "ref-service-status-in-progress";
    case "TREATED":
      return "ref-service-status-treated";
    case "CLEAR":
      return "ref-service-status-clear";
    case "CLOSED":
      return "ref-service-status-closed";
    case "OPEN":
      return "ref-service-status-open";
    default:
      return "ref-service-status-unknown";
  }
};

export const getRefServiceStatusColor = (
  status: string
): string => {
  switch (status) {
    case "NEEDS_SERVICE":
      return refServiceStatusNeedsServiceColorPalette.primary;
    case "BLOCKED":
      return refServiceStatusBlockedColorPalette.primary;
    case "IN_PROGRESS":
      return refServiceStatusInProgressColorPalette.primary;
    case "TREATED":
      return refServiceStatusTreatedColorPalette.primary;
    case "CLEAR":
      return refServiceStatusClearColorPalette.primary;
    case "CLOSED":
      return refServiceStatusClosedColorPalette.primary;
    case "OPEN":
      return refServiceStatusOpenColorPalette.primary;
    default:
      return refServiceStatusUnknownColorPalette.primary;
  }
};

export const getRefServiceStatusDisplayValue = (
  status: string,
  t: TFunction<"common"[], undefined, "common"[]>
): string => {
  const props = getIntlProps(status);
  return t(props.key, props.defaultValue)
};

const getIntlProps = (status: string): { key: string, defaultValue: string } => {
  switch (status) {
    case "NEEDS_SERVICE":
      return {
        key: "common.entity.refservicestatus.needsservice",
        defaultValue: "Needs Service"
      }
    case "BLOCKED":
      return {
        key: "common.entity.refservicestatus.blocked",
        defaultValue: "Blocked"
      }
    case "IN_PROGRESS":
      return {
        key: "common.entity.refservicestatus.inprogress",
        defaultValue: "In Progress"
      }
    case "TREATED":
      return {
        key: "common.entity.refservicestatus.treated",
        defaultValue: "Treated"
      }
    case "CLEAR":
      return {
        key: "common.entity.refservicestatus.clear",
        defaultValue: "Clear"
      }
    case "CLOSED":
      return {
        key: "common.entity.refservicestatus.closed",
        defaultValue: "Closed"
      }
    case "OPEN":
      return {
        key: "common.entity.refservicestatus.open",
        defaultValue: "Open"
      }
    default:
      return {
        key: "common.entity.refservicestatus.unknown",
        defaultValue: "Unknown"
      }
  }
};
